export enum SortDirection {
    ASC = 'ASC',
    DESC = 'DESC',
}

export interface Sort {
    property: string;
    direction: SortDirection;
}

export interface Pageable {
    page: number;
    size: number;
    sort: Sort[];
}
